import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { FC, HTMLProps } from "react";

const Section: FC<HTMLProps<HTMLDivElement>> = (props) => (
  <section className="px-4" {...props} />
);

const H1: FC<HTMLProps<HTMLHeadingElement>> = (props) => (
  <h1 className="py-8 text-4xl font-header" {...props} />
);

const H2: FC<HTMLProps<HTMLHeadingElement>> = (props) => (
  <h2 className="text-2xl mb-2 font-header" {...props} />
);

const H3: FC<HTMLProps<HTMLHeadingElement>> = (props) => (
  <h3 className="text-xl mb-2 font-header" {...props} />
);

const H4: FC<HTMLProps<HTMLHeadingElement>> = (props) => (
  <h4 className="text-base mb-2 font-header" {...props} />
);

const Block: FC<HTMLProps<HTMLParagraphElement>> = (props) => (
  <p className="mb-4" {...props} />
);

const Anchor: FC<HTMLProps<HTMLAnchorElement>> = (props) => (
  <a className="underline font-medium" target="_self" {...props} />
);

export default function Impressum() {
  return (
    <div className="bg-white">
      <Section className="px-4">
        <H1>Impressum und Datenschutz</H1>
        <Block>
          LichtBlick eMobility GmbH
          <br />
          Ostring 2-4
          <br />
          97228 Rottendorf
        </Block>

        <Block>
          Geschäftsführung: Sebastian Ewert
          <br />
          Telefon:{" "}
          <Anchor href="tel:+49 9321 9319 101">+49 9321 9319 101</Anchor>
          <br />
          E-Mail:{" "}
          <Anchor href="mailto:support.emobility@lichtblick.de">
            support.emobility@lichtblick.de
          </Anchor>
          <br />
          Web:{" "}
          <Anchor href="www.lichtblick.de/gewerbe/e-mobilitaet">
            www.lichtblick.de/gewerbe/e-mobilitaet
          </Anchor>
          <br />
          Bei Störungen erreichen sie uns kostenfrei unter folgender
          Telefonnummer:
          <br />
          <Anchor href="tel:+49 800 0670 000">+49 800 0670 000</Anchor>
        </Block>

        <Block>
          Sitz der Gesellschaft: Kitzingen
          <br />
          Registergericht: Amtsgericht Würzburg,
          <br />
          HRB 11191
          <br />
          Umsatzsteuer-ID/Umsatzsteuer-Identifikationsnummer gemäß §27 a
          Umsatzsteuergesetz: DE 269 711 773
          <br />
          Hinweis gemäß § 36 VSBG: Wir werden nicht an alternativen
          Streitschlichtungsverfahren im Sinne des § 36 VSBG teilnehmen. Die
          Nutzung einer alternativen Schlichtungsstelle stellt keine zwingende
          Voraussetzung für das Anrufen zuständiger ordentlicher Gerichte dar.
        </Block>

        <Block>
          Informationen zur Online-Streitbeilegung: Die Europäische Kommission
          stellt eine Plattform zur Online-Streitbeilegung (OS) bereit. Diese
          Plattform finden Sie unter folgendem Link:
          https://ec.europa.eu/consumers/odr.
          <br />
          Verbraucher können diese Plattform nutzen, um ihre Streitigkeiten aus
          Online-Verträgen beizulegen.
        </Block>
      </Section>

      <Section>
        <H1>Datenschutzhinweise</H1>

        <H2>1. Allgemein</H2>

        <Block>
          Wir, die LichtBlick eMobility GmbH (im Folgenden: LichtBlick) der
          Ladestation, nehmen den Schutz Ihrer personenbezogenen Daten ernst und
          halten uns strikt an die gesetzlichen Regeln der relevanten
          Datenschutz¬gesetze, insbesondere der Europäischen
          Datenschutzgrundver¬ordnung (EU DSGVO) sowie an diese
          Datenschutzerklärung.
          <br />
          Der Zweck dieser Datenschutzerklärung besteht darin, Sie über die
          Verarbei¬tung Ihrer personenbezogenen Daten zu informieren, die wir
          bei der Erbrin¬gung unserer Leistungen von Ihnen sammeln. Unsere
          Datenschutzpraxis steht im Einklang mit den gesetzlichen Regelungen
          der Datenschutzgrund¬verordnung der EU (DSGVO) und dem
          Bundesdatenschutzgesetz (BDSG). Die nachfolgende Datenschutzerklärung
          dient der Erfüllung der sich aus der DSGVO ergebenden
          Informationspflichten. Diese finden sich z.B. in Art. 13 und Art. 14
          ff. DSGVO.
          <br />
          Die vorliegende Datenschutzerklärung erstreckt sich auf die Leistung
          „Bezahlen von Ad-hoc-Ladevorgängen über eine Webseite“. Diese
          Datenschutzerklärung ist unter [URL] verfügbar.
        </Block>
      </Section>

      <Section>
        <H2>2. Verantwortlicher</H2>

        <Block>
          Verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten ist:
        </Block>
        <Block>
          LichtBlick eMobility GmbH
          <br />
          Steigweg 24
          <br />
          97318 Kitzingen
          <br />
          E-Mail:{" "}
          <Anchor href="mailto:datenschutz.eMobility@lichtblick.de">
            datenschutz.eMobility@lichtblick.de
          </Anchor>
          <br />
          Tel.: <Anchor href="tel:+49 9321 9319 101">+49 9321 9319 101</Anchor>
        </Block>
      </Section>

      <Section>
        <H2>3. Datenschutzbeauftragte von LichtBlick</H2>

        <Block>
          IDUCK
          <br />
          Institut für Datenschutz Unternehmensethik Compliance
          Korruptionsprävention
          <br />
          <Anchor href="www.duck.institute">www.duck.institute</Anchor>
          <br />
          CEO Prof. Dr. Angelika Kreitel
          <br />
          Boxhagener Str. 111
          <br />
          10245 Berlin
          <br />
          <Anchor href="mailto:datenschutz.emobility@lichtblick.de">
            datenschutz.emobility@lichtblick.de
          </Anchor>
        </Block>
      </Section>

      <Section>
        <H2>4. Zweck der Verarbeitung personenbezogener Daten</H2>

        <H3>
          4.1 Datenverarbeitung zur Erbringung der vertraglichen Leistungen
        </H3>

        <Block>
          Wir verarbeiten Ihre Daten, um die vertraglichen Verhältnisse zwischen
          Ihnen und uns abzuwickeln. Die Erhebung der Daten erfolgt dabei
          insbesondere zum Abschluss eines Vertrags über das Ad-Hoc-Laden von
          Elektrofahrzeugen (nachfolgend „Produkt“ genannt).
        </Block>

        <H4>
          4.1.1 Erfassung und Abrechnung von Ladevorgängen für den
          Ladestationsbetreiber
        </H4>

        <Block>
          Wir verarbeiten die Daten jedes Ad-Hoc-Ladevorgangs für den
          Ladestationsbetreiber, dessen Kontaktdaten sich auf der jeweils
          genutzten Ladesäule befinden. Die verarbeiteten Daten sind im
          Wesentlichen: Ladebeginn- und Ladeendzeit, Ladestationsnummer,
          Standort der Ladestation, Dauer des Ladevorgangs, geladene kWh und
          Bezahldaten („Ladevorgangsdaten“).
          <br />
          Wenn Sie einen Ladevorgang an einer Ladestation starten, über¬prüft
          LichtBlick, ob das gewählte Zahlungsmittel genutzt werden kann
          („Validierung“) und schaltet den Ladevorgang ggfs. frei. Nach
          Abschluss des Ladevorgangs teilen wir die „Ladevorgangsdaten“ (siehe
          obige Spezifikation) dem Ladestationsbetreiber mit („Abrechnung“).
          <br />
          Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 Buchst. b DSGVO,
          der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder
          vorvertraglicher Maßnahmen gestattet.
        </Block>

        <H4>4.1.2 Datenverarbeitung zur Kommunikation mit Ihnen</H4>

        <Block>
          Neben den Vertragsdaten verarbeiten wir Ihre E-Mail-Adresse, sofern
          Sie uns diese über das Web-Formular mitgeteilt haben, um mit Ihnen in
          Kon¬takt treten zu können. Die E-Mail-Adresse wird nur zur
          Korrespondenz mit Ihnen verarbeitet.
          <br />
          Wir erfassen darüber hinaus in Einzelfällen Telefongespräche mit
          unseren Kundendienstmitarbeitern oder mit Dritten, die unseren
          Kundendienst unter¬stützen, um Probleme zu lösen und technische
          Unterstützung und Beratung anzubieten.
          <br />
          Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 Buchst. b DSGVO,
          der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder
          vorvertraglicher Maßnahmen gestattet.
        </Block>

        <H3>4.2 Datenverarbeitung zur Wahrung berechtigter Interessen</H3>

        <Block>
          Ihre Daten verarbeiten wir auch, wenn es erforderlich ist, um
          berechtigte Interessen von uns oder von Dritten zu wahren. Dies kann
          insbesondere der Fall sein zur Gewährleistung der IT-Sicherheit und
          des IT-Betriebs, insbe¬sondere auch bei Support-Anfragen, um im Falle
          rechtlicher Auseinander¬setzungen Sachverhalte nachvollziehen und
          belegen zu können, für Markt- und Meinungsumfragen, um die Nutzung
          unserer Webseite statistisch auszuwerten, zur Werbung für andere
          Produkte von uns oder unserer Kooperationspartner.
          <br />
          Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 Buchst. f DSGVO.
          Wir haben ein berechtigtes Interesse an den vorstehend aufgeführten
          Daten-verarbeitungen.
        </Block>

        <H3>
          4.3. Datenverarbeitung zur Erfüllung gesetzlicher Verpflichtungen
        </H3>

        <Block>
          Darüber hinaus verarbeiten wir Ihre Daten zur Erfüllung gesetzlicher
          Ver-pflichtungen (z.B. aufsichtsrechtlicher Vorgaben, handels- und
          steuer-rechtlicher Aufbewahrungs- und Nachweispflichten).
          <br />
          Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 Buchst. c DSGVO,
          der die Verarbeitung zur Erfüllung einer rechtlichen Verpflichtung
          gestattet.
        </Block>
      </Section>

      <Section>
        <H2>5. Gemeinsame Verantwortlichkeit nach Art. 26 DSGVO</H2>

        <Block>
          Wir, die LichtBlick eMobility GmbH und der mitverantwortliche
          Ladestationsbetreiber, sind gemeinsam für die Verarbeitung Ihrer
          personenbezogenen Daten im Rahmen der Nutzung der Ladesäulen
          verantwortlich. Diese gemeinsame Verantwortlichkeit bedeutet, dass wir
          zusammen die Zwecke und Mittel der Verarbeitung Ihrer Daten festlegen.
          In einer transparenten Vereinbarung haben wir festgelegt, wer von uns
          welche Verpflichtungen gemäß der DSGVO erfüllt, insbesondere in Bezug
          auf die Wahrnehmung Ihrer Rechte und die Erfüllung der
          Informationspflichten. Diese Vereinbarung spiegelt unsere jeweiligen
          tatsächlichen Funktionen und Beziehungen Ihnen gegenüber wider.
          Ungeachtet der Einzelheiten der Vereinbarung können Sie Ihre Rechte im
          Rahmen der DSGVO bei und gegenüber jedem einzelnen von uns geltend
          machen.
        </Block>
      </Section>

      <Section>
        <H2>6. Bezahlvorgang mit Stripe</H2>

        <Block>
          Wir bieten die Zahlung mit den Diensten von Stripe an. Anbieter für
          Kund*innen innerhalb der EU ist Stripe Payments Europe, Ltd., 1 Grand
          Canal Street Lower, Grand Canal Dock, Dublin, Irland (nachfolgend
          „Stripe“ genannt). Bei einer Zahlung via Stripe werden Ihre
          Zahlungsdaten über eine Schnittstelle auf unserer Seite an Stripe
          weitergeleitet, um die Bezahlung durchzuführen. Details hierzu können
          Sie in der Datenschutzerklärung von Stripe unter folgendem Link
          nachlesen: https://stripe.com/de/privacy. Die Übermittlung Ihrer Daten
          an Stripe erfolgt auf Grundlage des Art. 6 Abs. 1 S. 1 lit. b DSGVO
          (Verarbeitung zur Erfüllung eines Vertrags) sowie auf Basis unseres
          berechtigten Interesses am Einsatz von verlässlichen und sicheren
          Zahlungsprozessen (Art. 6 Abs. 1 S. 1 lit. f DSGVO).
        </Block>
      </Section>

      <Section>
        <H2>7. Dauer der Datenspeicherung</H2>
        <Block>
          Grundsätzlich löschen wir Ihre Daten, sobald sie für die oben
          genannten Zwecke nicht mehr erforderlich sind, es sei denn, die
          vorübergehende Auf-bewahrung ist weiterhin notwendig. So speichern wir
          Ihre Daten aufgrund gesetzlicher Nachweis- und Aufbewahrungspflichten,
          die sich unter anderem aus dem Handelsgesetzbuch und der
          Abgabenordnung ergeben. Die Speicherfristen betragen danach bis zu
          zehn Jahre.
        </Block>
      </Section>

      <Section>
        <H2>8. Datensicherheit</H2>

        <Block>
          Ihre persönlichen Daten werden bei uns sicher durch Verschlüsselung
          über¬tragen. Wir bedie¬nen uns dabei des Codierungssystems SSL (Secure
          Socket Layer). Eine ver¬schlüsselte Verbindung erkennen Sie daran,
          dass die Adresszeile des Brow¬sers von „http://“ auf „https://“
          wechselt und an dem Schloss-Symbol in Ihrer Browserzeile. Des Weiteren
          sichern wir unsere Webseiten und sonstige Systeme durch technische und
          organisatorische Maßnahmen gegen Verlust, Zerstörung, Zugriff,
          Veränderung oder Verbreitung Ihrer Daten durch unbe¬fugte Personen ab.
          <br />
          Wir weisen darauf hin, dass die Datenübertragung im Internet
          Sicherheits-lücken aufweisen kann. Ein lückenloser Schutz der Daten
          vor dem Zugriff durch Dritte ist nicht möglich.
          <br />
          Alle Partner sind über Verträge zur Auftragsverarbeitung nach Art. 28
          DSGVO in die Leistungserbringung eingebunden.
        </Block>
      </Section>

      <Section>
        <H2>9. Betroffenenrechte gemäß DSGVO</H2>

        <Block>
          Als betroffene Person haben Sie folgende Rechte in Bezug auf die
          Speiche-rung und Verarbeitung Ihrer personenbezogenen Daten:
        </Block>

        <H3>9.1 Widerspruchsrecht gemäß Art. 21</H3>

        <Block>
          Sie können Ihre Einwilligung, so weit erteilt, zu jeder Zeit und ohne
          Angabe von Gründen widerrufen und Widerspruch gegen die Verarbeitung
          einlegen.
        </Block>

        <H3>9.2 Auskunftsrecht gemäß Art. 15</H3>

        <Block>
          Sie haben das Recht, jederzeit Auskunft über Ihre von uns
          gespeicherten und verarbeiteten personenbezogenen Daten zu verlangen.
        </Block>

        <H3>9.3 Recht auf Berichtigung gemäß Art. 16</H3>

        <Block>
          Sollten Ihre Angaben nicht bzw. nicht mehr zutreffend oder
          unvollständig sein, können Sie jederzeit deren Berichtung und/oder
          Vervollständigung verlangen.
        </Block>

        <H3>9.4 Recht auf Löschung gemäß Art. 17</H3>

        <Block>
          Sie haben das Recht auf Löschung Ihrer durch uns verarbeiteten
          personen-bezogenen Daten. Sollten Sie die Löschung Ihrer
          personenbezogenen Daten bei uns verlangen, werden wir dies sorgfältig
          prüfen und, sofern keine ge¬setzlichen Aufbewahrungspflichten der
          Löschung entgegenstehen, Ihre personenbezogenen Daten löschen.
        </Block>

        <H3>9.5 Recht auf Einschränkung der Verarbeitung gemäß Art. 18</H3>

        <Block>
          Sollten Ihrem Löschersuchen gesetzliche Aufbewahrungspflichten
          entgegen¬stehen, so werden wir Ihre personenbezogenen Daten für die
          Verarbeitung einschränken.
        </Block>

        <H3>9.6 Recht auf Übertragbarkeit gemäß Art. 20</H3>

        <Block>
          Sie haben das Recht, Ihre personenbezogenen Daten von uns zu jederzeit
          in einem übertragbaren und maschinenlesbaren Format zu erhalten, um
          diese zu einer anderen Einrichtung mitzunehmen.
        </Block>

        <H3>9.7 Beschwerderecht gemäß Art. 77</H3>

        <Block>
          Sollten Sie Grund zur Beanstandung der Datenverarbeitung haben, haben
          Sie das Recht, sich an unseren Datenschutzbeauftragten, E-Mailadresse:
          datenschutz.eMobility@lichtblick.de, zu wenden.
          <br />
          Daneben haben Sie das Recht, sich an eine Datenschutzaufsichtsbehörde
          zu wenden. Sofern Sie den Verdacht haben, dass Ihre Daten rechtswidrig
          ver¬arbeitet werden, können Sie selbstverständlich jederzeit eine
          gerichtliche Klärung der Problematik herbeiführen. Zudem steht Ihnen
          jede andere rechtliche Möglichkeit offen.
          <br />
          Das Beschwerderecht gem. Art. 77 DSGVO steht Ihnen in dem
          EU-Mitglied-staat Ihres Aufenthaltsortes, Ihres Arbeitsplatzes
          und/oder des Ortes des vermeintlichen Verstoßes zu, d.h. Sie können
          die Aufsichtsbehörde, an die Sie sich wenden, aus den oben genannten
          Orten wählen. Die Aufsichts-behörde, bei der die Beschwerde
          eingereicht wurde, unterrichtet Sie dann über den Stand und die
          Ergebnisse Ihrer Eingabe, einschließlich der Mög-lichkeit eines
          gerichtlichen Rechtsbehelfs gem. Art. 78 DSGVO.
        </Block>
      </Section>
    </div>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || "de", ["common", "consent"])),
    },
  };
};
